import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import { cloneValue, expectObject, readString, splitKnown } from "../utils";

export class ProductVersionTechpackAnnexeModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    id: { label: "ID", fieldType: "text" },
    pdfAnnexe: { label: "PDF Annexe URL", fieldType: "text" },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  id!: string;
  pdfAnnexe!: string;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("id", "");
    this.defineObservableValue("pdfAnnexe", "");
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product techpack annexe");
    this.id = readString(source, "id");
    this.pdfAnnexe = readString(source, "pdfAnnexe");
    this.extra = splitKnown(source, ["id", "pdfAnnexe"]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.id ? { id: this.id } : {}),
      ...(this.pdfAnnexe ? { pdfAnnexe: this.pdfAnnexe } : {}),
    };
  }
}
